var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgShipTransporterSeneca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d9faff;\n      }\n\n      .cls-2 {\n        fill: #b1e1e5;\n      }\n\n      .cls-3 {\n        fill: #e9fbff;\n      }\n\n      .cls-4 {\n        fill: aqua;\n      }\n\n      .cls-5 {\n        fill: #4c3547;\n      }\n\n      .cls-6 {\n        fill: #c9ecf2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "123.9 303.05 148.18 273.05 523.92 345.91 611.07 415.92 95.58 416.38 123.9 303.05"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "123.9 303.05 148.18 263.05 461.31 313.43 523.92 345.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "106.75 428.78 596.78 428.78 611.07 415.92 95.32 415.92 106.75 428.78"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "120.96 443.6 581.56 443.6 594.12 428.94 108.4 428.94 120.96 443.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "207.01 416.38 611.32 416.38 524.17 346.37 418.45 334.94 207.01 416.38"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "123.9 303.05 148.18 273.05 523.92 345.91 611.07 415.92 95.58 416.38 123.9 303.05"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "123.9 303.05 148.18 263.05 461.31 313.43 523.92 345.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "106.75 428.78 596.78 428.78 611.07 415.92 95.32 415.92 106.75 428.78"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "120.96 443.6 581.56 443.6 594.12 428.94 108.4 428.94 120.96 443.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "207.01 416.38 611.32 416.38 524.17 346.37 418.45 334.94 207.01 416.38"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgShipTransporterSeneca);
export default __webpack_public_path__ + "static/media/bg-ship-transporter-seneca.a3f40059077173975cbea1e941ff183e.svg";
export { ForwardRef as ReactComponent };